import gql from "graphql-tag";

const CREATE_CLAIM_INTENT = gql`
  mutation createClaimIntent(
    $poolId: String!
    $walletAddress: String!
    $networkId: BlockchainNetworks!
  ) {
    createClaimIntent(
      createClaimIntentInput: {
        poolId: $poolId
        walletAddress: $walletAddress
        networkId: $networkId
      }
    ) {
      id
      walletAddress
      networkId
      userId
      poolId
    }
  }
`;

export default CREATE_CLAIM_INTENT;
